var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 row mx-0 px-0",attrs:{"id":"article-create"}},[_c('article-content',{attrs:{"article-id":_vm.articleId},on:{"edited":_vm.edited,"updated":_vm.updateCurrentArticle,"cover":_vm.setPreviewCover}}),_vm._v(" "),_c('article-preview',{attrs:{"cover-url":_vm.coverUrl,"content":_vm.previewContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }